import { render } from "./CompanyAddUpdate.vue?vue&type=template&id=3e10789a&scoped=true"
import script from "./CompanyAddUpdate.vue?vue&type=script&lang=js"
export * from "./CompanyAddUpdate.vue?vue&type=script&lang=js"

import "./CompanyAddUpdate.vue?vue&type=style&index=0&id=3e10789a&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e10789a"]])

export default __exports__